module.exports = __webpack_public_path__ + "static/media/chromecast.5dbaec68.png";